var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path, Rect, Mask, G } from "react-native-svg";
var SvgFeedLikes = function SvgFeedLikes(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M4 1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1H4V1Z",
    fill: "currentColor",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M2 3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v1H2V3Z",
    fill: "currentColor",
    style: {
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 0.75,
    y: 4.75,
    width: 22.5,
    height: 22.5,
    rx: 1.25,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 0.75,
    y: 4.75,
    width: 22.5,
    height: 22.5,
    rx: 1.25,
    style: {
      fill: "none"
    },
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement(Mask, {
    id: "feed-likes_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 16,
    height: 16
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M4 8h16v16H4z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#feed-likes_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12 21.486-.205.471h-.002l-.004-.003-.016-.006a5.443 5.443 0 0 1-.262-.124 15.825 15.825 0 0 1-2.91-1.85c-1.574-1.273-3.268-3.22-3.268-5.75v-.008c.013-.869.27-1.716.743-2.427a4.02 4.02 0 0 1 1.918-1.547 3.717 3.717 0 0 1 2.415-.077c.597.185 1.14.514 1.591.958.45-.444.994-.773 1.591-.957a3.717 3.717 0 0 1 2.415.075 4.02 4.02 0 0 1 1.918 1.548c.473.711.73 1.558.743 2.427v.007c0 2.53-1.694 4.478-3.268 5.75a15.817 15.817 0 0 1-3.172 1.975l-.016.006-.004.002-.002.001-.205-.471Zm0 0 .204.471a.512.512 0 0 1-.409 0l.205-.471Z",
    fill: "currentColor"
  }))));
};
export default SvgFeedLikes;